import './init/jquery';
import './init/jquery-ui';
import './init/jquery-ui-bootstrap';
import './init/bootstrap';
import './init/globalize';
import './init/mustache';

import App from './core/App';

export default new App();


// WEBPACK FOOTER //
// ./app.js